import React, { useState } from 'react';

interface ProfileProps {
  profile: {
    email: string;
    displayName: string;
    stats: {
      podcastsGenerated: number;
      lastGenerated: string;
    };
  };
  onUpdateProfile: (update: { displayName: string }) => Promise<void>;
  loading: boolean;
  error: string | null;
  onLogout: () => void;
  onShowHistory?: () => void;
}

const Profile: React.FC<ProfileProps> = ({ profile, onUpdateProfile, loading, error, onLogout, onShowHistory }) => {
  const [editing, setEditing] = useState(false);
  const [displayName, setDisplayName] = useState(profile.displayName);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    await onUpdateProfile({ displayName });
    setSaving(false);
    setEditing(false);
  };

  if (loading) {
    return <div data-testid="profile-loading" className="flex justify-center items-center h-40">Loading...</div>;
  }

  return (
    <div className="p-8 max-w-md mx-auto bg-white rounded-2xl shadow-2xl space-y-6 border border-gray-100 flex flex-col items-center">
      {/* Avatar */}
      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-violet-500 flex items-center justify-center text-white text-3xl font-bold mb-2 shadow-md">
        {profile.displayName.charAt(0).toUpperCase()}
      </div>
      <h2 className="text-2xl font-bold mb-1">User Profile</h2>
      {error && <div className="text-red-500 mb-2 text-center">{error}</div>}
      <div className="mb-2 w-full text-center">
        <span className="font-medium">Email:</span> <span className="text-gray-700">{profile.email}</span>
      </div>
    </div>
  );
};

export default Profile;